/* eslint-disable max-len */
export const USER_ADDED = 'User successfully added!';
export const USER_EDITED = 'User successfully modified!';
export const USER_DELETED = 'User successfully removed!';

export const COMPANY_ADDED = 'Company successfully added!';
export const COMPANY_EDITED = 'Company successfully modified!';
export const COMPANY_DELETED = 'Company successfully removed!';

export const REGULATOR_ADDED = 'Regulator successfully added!';
export const REGULATOR_EDITED = 'Regulator successfully modified!';
export const REGULATOR_DELETED = 'Regulator successfully removed!';

export const ACCOUNT_EDITED = 'Account information successfully saved!';
export const ACCOUNT_LOCKOUT_EDITED = 'Account lockout status successfully saved!';

export const ADVERSE_EVENT_ATTESTED = 'Attested successfully!';
export const ADVERSE_EVENT_DELETED = 'Adverse event(s) successfully removed!';

export const USAGE_DATA_UPDATED = 'Shipping data successfully saved!';

export const PRODUCT_ADDED = 'Product successfully added!';
export const PRODUCT_EDITED = 'Product changes successfully saved!';
export const PRODUCT_DELETED = 'Product(s) successfully removed!';
export const PRODUCT_DELETE_GUIDANCE = 'Member products will be moved to membertest. Once deleted from membertest, the selected product(s) cannot be recovered!';
export const PRODUCT_COPIED = 'Product copied successfully! Save the product for changes to take effect.';

export const PRODUCT_SIGNATURE_ADDED = 'Product signature successfully applied!';
export const PRODUCT_SIGNATURE_DELETED = 'Product signature successfully removed!';

export const PRODUCT_DISCONTINUED_EDITED = 'Product discontinued status successfully saved!';
export const DISCONTINUED_PREFERENCE_CHANGED = 'Product discontinued preference successfully saved!';
export const PRODUCT_DISCONTINUATION_GUIDANCE = 'Products should only be discontinued if they are no longer being sold or if there has been a formulation change. For other changes, such as label updates or corrections, the product should be unsigned instead. Please contact your account manager if needed.';

export const PRODUCT_LABEL_COMMITTED = 'Product label successfully changed!';
export const PRODUCT_LABEL_CHANGED = 'Product label successfully changed! Save the product for changes to take effect.';
export const PRODUCT_LABEL_CHANGED_ERROR = 'Unable to upload file! Try again in Google Chrome, Firefox, Safari, Edge, or IE10.';

export const ADMINISTRATION_ADDED = 'Administration successfully added!';
export const ADMINISTRATION_EDITED = 'Administration changes successfully saved!';
export const ADMINISTRATION_DELETED = 'Administration successfully removed!';

export const PRODUCT_INGREDIENT_ADDED = 'Ingredient successfully added!';
export const PRODUCT_INGREDIENT_EDITED = 'Ingredient changes successfully saved!';
export const PRODUCT_INGREDIENT_DELETED = 'Ingredient successfully removed!';

export const ADVERSE_EVENT_ADDED = 'Adverse event successfully added!';
export const ADVERSE_EVENT_EDITED = 'Adverse event changes successfully saved!';
export const ADVERSE_EVENT_CLOSED = 'Adverse event successfully closed!';

export const PASSWORD_CHANGED = 'Password successfully changed!';
export const PASSWORD_RESET = 'Password successfully reset.';
export const FORGOT_PASSWORD_CONFIRMED = 'Please check your email to retrieve your NASC credentials!';

export const SYSTEM_INGREDIENT_ADDED = 'System ingredient successfully added!';
export const SYSTEM_INGREDIENT_EDITED = 'System ingredient changes successfully saved!';
export const SYSTEM_INGREDIENT_DELETED = 'System ingredient successfully removed!';

export const USER_INGREDIENT_ADDED = 'User ingredient successfully added!';
export const USER_INGREDIENT_EDITED = 'User ingredient changes successfully saved!';
export const USER_INGREDIENT_DELETED = 'User ingredient successfully removed!';
export const USER_INGREDIENT_DELETE_CONFIRMATION = 'Once deleted, the selected ingredient(s) cannot be recovered. They will also be removed from any products containing them.';

export const CATEGORY_ADDED = 'Category successfully added!';
export const CATEGORY_EDITED = 'Category changes successfully saved!';
export const CATEGORY_DELETED = 'Category successfully removed!';

export const SYSTEM_MESSAGE_CHANGED = 'System message changes successfully saved!';
export const COMPANY_MESSAGE_CHANGED = 'Company message changes successfully saved!';

export const INGREDIENT_RISK_REPORT_GENERATED = 'Ingredient risk report successfully generated!';
/* eslint-enable max-len */



// WEBPACK FOOTER //
// ./common/messages.js